import { ClientService } from '@/services/client';
import { NavigatorService } from '@/services/navigator';
import type { ICfUserAddress } from '@/types/interfaces/chocofood';

const DEFAULT_ADDRESS: ICfUserAddress = {
	apartment: '',
	coordinates: {
		longitude: 0,
		latitude: 0
	}
};

const wrapper = (defaultTown: string): (() => ICfUserAddress) => {
	const town = NavigatorService.getTownById(ClientService.state.townId);

	return () => ({
		...DEFAULT_ADDRESS,
		city: town ? town.name : defaultTown
	});
};

export const getDefaultAddress = wrapper(NavigatorService.state.towns[0].name);
